"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DurationTrip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("./utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _DurationTripField = require("./components/DurationTripField");
var DurationTrip = exports.DurationTrip = function DurationTrip(props) {
  var leftValue = props.leftValue,
    rightValue = props.rightValue,
    shift = props.shift,
    monthMode = props.monthMode,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    isWizard = props.isWizard,
    searchType = props.searchType,
    _props$isOpenCalendar = props.isOpenCalendar,
    isOpenCalendar = _props$isOpenCalendar === void 0 ? false : _props$isOpenCalendar,
    onStartDateClick = props.onStartDateClick,
    onEndDateClick = props.onEndDateClick,
    onStartDateClear = props.onStartDateClear,
    onEndDateClear = props.onEndDateClear,
    isStartDateFocus = props.isStartDateFocus,
    isEndDateFocus = props.isEndDateFocus,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    _props$isWhiteLabel = props.isWhiteLabel,
    isWhiteLabel = _props$isWhiteLabel === void 0 ? false : _props$isWhiteLabel;
  var _ref = monthMode ? _constants.fieldParams.month : _constants.fieldParams.days,
    _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
    leftParams = _ref2[0],
    rightParams = _ref2[1];
  var color = isMobile ? '#c2c5cc' : '#919499';
  var _convertDatePickerPar = (0, _utils.convertDatePickerParamsToStrings)({
      leftValue: leftValue,
      rightValue: rightValue,
      shift: shift
    }),
    left = _convertDatePickerPar.left,
    right = _convertDatePickerPar.right;
  var leftPlaceholder = isOpenCalendar && !leftValue && isStartDateFocus ? '...' : undefined;
  var rightPlaceholder = isOpenCalendar && !rightValue && isEndDateFocus ? '...' : undefined;
  return /*#__PURE__*/_react["default"].createElement(DurationTripFieldContainer, {
    $isWizard: isWizard,
    $isMobile: isMobile,
    $color: color,
    $active: !!(leftValue && rightValue),
    $variant: variant
  }, /*#__PURE__*/_react["default"].createElement(_DurationTripField.DurationTripField, (0, _extends2["default"])({
    onClick: onStartDateClick,
    onClear: onStartDateClear,
    value: left,
    isMobile: isMobile,
    isWizard: isWizard,
    searchType: searchType,
    isActive: isOpenCalendar && isStartDateFocus,
    placeholderText: leftPlaceholder,
    variant: variant,
    isWhiteLabel: isWhiteLabel
  }, leftParams)), isWizard && /*#__PURE__*/_react["default"].createElement(SplitArrowContainer, null, "\u2013"), /*#__PURE__*/_react["default"].createElement(DurationTripFieldBack, (0, _extends2["default"])({
    onClick: onEndDateClick,
    onClear: onEndDateClear,
    value: right,
    isMobile: isMobile,
    isWizard: isWizard,
    searchType: searchType,
    isActive: isOpenCalendar && isEndDateFocus,
    placeholderText: rightPlaceholder,
    $leftValue: !!leftValue && !rightValue,
    variant: variant,
    $isMobile: isMobile,
    isWhiteLabel: isWhiteLabel
  }, rightParams)));
};
var DurationTripFieldContainer = _styledComponents["default"].div.withConfig({
  displayName: "DurationTrip__DurationTripFieldContainer",
  componentId: "sc-17i2tp2-0"
})(["display:inline-flex;cursor:pointer;justify-content:center;align-items:center;gap:", ";color:", ";position:relative;min-height:52px;", " ", ";", ";"], function (_ref3) {
  var $isMobile = _ref3.$isMobile,
    $isWizard = _ref3.$isWizard;
  return $isMobile && !$isWizard ? '8px' : '0';
}, function (_ref4) {
  var $active = _ref4.$active,
    $color = _ref4.$color;
  return $active ? '#17181A' : $color;
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile,
    $variant = _ref5.$variant;
  return !$isMobile && $variant !== 'hotel' && _styles.leftBorder;
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile;
  return $isMobile && "width: 100%";
}, function (_ref7) {
  var $isMobile = _ref7.$isMobile;
  return !$isMobile && "z-index: 3";
});
var SplitArrowContainer = _styledComponents["default"].span.withConfig({
  displayName: "DurationTrip__SplitArrowContainer",
  componentId: "sc-17i2tp2-1"
})(["color:inherit;"]);
var DurationTripFieldBack = (0, _styledComponents["default"])(_DurationTripField.DurationTripField).withConfig({
  displayName: "DurationTrip__DurationTripFieldBack",
  componentId: "sc-17i2tp2-2"
})(["", " ", ""], function (_ref8) {
  var $leftValue = _ref8.$leftValue;
  return $leftValue && 'z-index: 99; cursor: default';
}, function (_ref9) {
  var $isMobile = _ref9.$isMobile;
  return !$isMobile && _styles.leftBorder;
});